export default "__VITE_ASSET__BQrdui7W__"